import Link from "next/link"

import {
  NavIcon,
  navLabelAppearance,
  type NavIconName
} from "@/components/ui/nav-icon"
import { cn } from "@/lib/utils"

export type NavLinkProps = {
  href: string
  label: string
  icon: NavIconName
  isActive?: boolean
  comingSoon?: boolean
  className?: string
  iconClassName?: string
  labelClassName?: string
}

export function NavLink({
  href,
  label,
  icon,
  isActive = false,
  comingSoon = false,
  className,
  iconClassName,
  labelClassName
}: NavLinkProps) {
  const rootClassName = cn(
    "inline-flex items-center overflow-visible text-white/50 transition-colors",
    isActive && "text-white",
    comingSoon && "pointer-events-none opacity-50",
    className
  )

  return (
    <Link
      href={href}
      className={rootClassName}
      aria-current={isActive ? "page" : undefined}
    >
      <NavIcon
        name={icon}
        variant={isActive ? "active" : "inactive"}
        className={iconClassName}
      />
      <span
        className={cn(
          "font-semibold leading-none",
          isActive ? navLabelAppearance.active : navLabelAppearance.inactive,
          labelClassName
        )}
      >
        {label}
      </span>
    </Link>
  )
}
